var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.438 25.8525C20.7617 26.2673 19.8955 26.4958 18.999 26.4958C18.1026 26.4958 17.2364 26.2674 16.5601 25.8525L5.51813 19.0804C5.51813 19.0804 4.52148 18.4695 4.52148 19.8534V26.6158C4.52148 30.1782 11.0032 34.0186 18.9988 34.0186C26.9943 34.0186 33.476 30.1783 33.476 26.6158V19.4721C33.476 18.3613 32.7675 18.9041 32.7675 18.9041L21.438 25.8525Z",
    fill: "#134046"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3637 13.6941C38.2121 13.1737 38.2121 12.3222 37.3637 11.8018L20.5426 3.39024C19.6941 2.86992 18.3058 2.86992 17.4573 3.39024L0.636333 11.8018C-0.212111 12.3222 -0.212111 13.1736 0.636333 13.6941L17.4573 24.0106C18.3058 24.5309 19.6941 24.5309 20.5426 24.0106M36.668 28.9855V17.5918C36.668 17.5918 36.6759 17.0521 36.3557 17.2303C36.0988 17.3733 35.4691 17.7243 35.2473 17.9172C34.9912 18.1398 35.0489 18.6395 35.0489 18.6395V28.9855C35.0489 29.1324 34.9227 29.2025 34.8625 29.2379C34.2811 29.5797 33.8901 30.2107 33.8901 30.9341C33.8901 32.0213 34.7713 32.9026 35.8585 32.9026C36.9456 32.9026 37.8268 32.0213 37.8268 30.9341C37.8268 30.208 37.433 29.575 36.8478 29.234C36.7896 29.2001 36.668 29.1323 36.668 28.9855Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/education_icon.1afdfe20c958eb85c79de914e821549f.svg";
export { ForwardRef as ReactComponent };